/**
 * 18+ age gate (specs/coin-compliance).
 * AGE_MINIMUM mirrors server/src/helpers/ageGate.helper.js — the server is the authority;
 * the client uses it only to validate before submitting.
 */

export const AGE_MINIMUM = 18
export const EARLIEST_BIRTH_YEAR = 1900

export const AGE_GATE_API_CODES = {
  INELIGIBLE: 'AGE_INELIGIBLE',
  VERIFICATION_REQUIRED: 'AGE_VERIFICATION_REQUIRED',
  INVALID_BIRTH_DATE: 'INVALID_BIRTH_DATE',
  BIRTH_DATE_ALREADY_SET: 'BIRTH_DATE_ALREADY_SET',
} as const

/**
 * Routes where the global modal stays hidden: a new guest answers the age question as a step
 * of the onboarding questionnaire instead (specs/onboarding-questionnaire Story 7, AC-21).
 */
export const AGE_GATE_MODAL_SUPPRESSED_PATHS: readonly string[] = ['/app/tutorial', '/app/onboarding']

export const AGE_GATE_SUPPORT_EMAIL = 'info@zporti.com'

/**
 * The prompt copy deliberately does not state the minimum age: a neutral question does not
 * coach users towards the answer that gets them in (AC-1.2).
 */
export const AGE_GATE_COPY = {
  PROMPT_TITLE: 'What is your date of birth?',
  PROMPT_BODY: 'We need this once to set up your account.',
  DAY_LABEL: 'Day',
  MONTH_LABEL: 'Month',
  YEAR_LABEL: 'Year',
  DAY_PLACEHOLDER: 'DD',
  MONTH_PLACEHOLDER: 'MM',
  YEAR_PLACEHOLDER: 'YYYY',
  CONTINUE: 'Continue',
  CONFIRM_TITLE: 'Is this right?',
  CONFIRM_BODY: 'Your date of birth can’t be changed later, so please check it.',
  EDIT: 'Edit',
  CONFIRM: 'Confirm',
  INVALID_DATE: 'Enter a real date of birth.',
  SUBMIT_FAILED: 'We couldn’t save that. Check your connection and try again.',
  BLOCKED_TITLE: 'Zporti is for adults',
  BLOCKED_BODY: 'You need to be 18 or older to use Zporti.',
  BLOCKED_SUPPORT: `If you think this is a mistake, contact ${AGE_GATE_SUPPORT_EMAIL}.`,
  SIGN_OUT: 'Sign out',
} as const

export const AGE_GATE_TEST_IDS = {
  PROMPT: 'age-gate-prompt',
  DAY: 'age-gate-day',
  MONTH: 'age-gate-month',
  YEAR: 'age-gate-year',
  CONTINUE: 'age-gate-continue',
  CONFIRM_VIEW: 'age-gate-confirm',
  CONFIRM_DATE: 'age-gate-confirm-date',
  EDIT: 'age-gate-edit',
  CONFIRM: 'age-gate-confirm-button',
  ERROR: 'age-gate-error',
  BLOCKED: 'age-gate-blocked',
  SIGN_OUT: 'age-gate-sign-out',
} as const
